import { useState, useRef, useEffect } from "react";
import { stockSearch } from "../api/user";

export default function SearchBar1({ onResults, onCategoryChange, name }) {
  const [category, setCategory] = useState("Stocks");
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const controllerRef = useRef(null);
  const debounceRef = useRef(null);
  const capitalizeFirst = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  useEffect(() => {
    if (!name) return;
    const lower = name.toLowerCase();

    if (lower.includes("stocks")) setCategory("Stocks");
    else if (lower.includes("forex")) setCategory("Forex");
    else if (lower.includes("crypto")) setCategory("Crypto");
  }, [name]);

  const handleCategoryChange = async (e) => {
    const newCategory = e.target.value;
    setCategory(newCategory);

    let defaultKey = null;
    if (newCategory === "Stocks") defaultKey = "stocks";
    else if (newCategory === "Forex") defaultKey = "forex";
    else if (newCategory === "Crypto") defaultKey = "crypto";

    try {
      if (defaultKey) {
        onCategoryChange?.(defaultKey);
      }
    } catch (err) {
      console.error("Error updating parent category:", err);
    }
  };

  useEffect(() => {
    const trimmed = query.trim();

    if (!trimmed) {
      setResults([]);
      onResults([]);
      return;
    }

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      if (controllerRef.current) controllerRef.current.abort();
      const controller = new AbortController();
      controllerRef.current = controller;

      setLoading(true);
      try {
        const data = { category, query: trimmed };
        const response = await stockSearch(data, controller.signal);
        const newResults = response.data || [];
        setResults(newResults);
        onResults(newResults);
      } catch (err) {
        if (err.name === "CanceledError") {
        } else {
          console.error("Search failed:", err);
        }
        setResults([]);
        onResults([]);
      } finally {
        setLoading(false);
      }
    }, 400);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [query, category, onResults]);

  return (
    <div className="flex flex-col gap-4 mb-4 relative pt-2">
      <h2 className="text-xl font-semibold text-gray-700">
        Search {capitalizeFirst(category)}
      </h2>

      <div className="flex gap-2">
        <select
          value={category}
          onChange={handleCategoryChange}
          className="px-4 py-2 rounded-full border bg-white focus:outline-none"
        >
          <option value="Stocks">Stocks</option>
          <option value="Forex">Forex</option>
          <option value="Crypto">Crypto</option>
        </select>

        <div className="flex items-center border rounded-full px-3 flex-1 bg-white">
          <input
            type="text"
            className="w-full p-2 border-none focus:outline-none rounded-full"
            placeholder={`Search ${category.toLowerCase()}...`}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>

      {loading && (
        <div className="text-center text-sm text-gray-500 mt-2">
          Loading results...
        </div>
      )}
    </div>
  );
}
